import {get} from 'lodash';
import { RELATED_CONTENT_MODULE, VIDEO_SERIES_PAGE_TYPE } from '../../constants';

/**
 * Asserts if the related content module should be rendered.
 *
 * @param  {string} page_type
 * @return {bool}
 */
const showRelatedContent = (page_type: string): bool => ([VIDEO_SERIES_PAGE_TYPE].indexOf(page_type) === -1);

/**
 * Array of validators for handling module inclusion logic.
 *
 * @constant {Object.<string, function>[]}
 */
const MODULE_VALIDATORS = {
  [RELATED_CONTENT_MODULE]: showRelatedContent
};

/**
 * Asserts that the argument is a function
 *
 * @param {*} val
 */
const isFunction = (val: any): bool => (typeof val === 'function');

/**
 * Asserts if a module should be rendered.
 *
 * @param  {string} module_type
 * @param  {string} page_type
 * @return {bool}
 */
export default (module_type: string, page_type: string): bool => {
  const validator = get(MODULE_VALIDATORS, module_type);
  return isFunction(validator) ? validator(page_type) : true;
};
